import React, { useEffect, Suspense, lazy, useState } from "react";
import * as actionCreators from './actions';
import { Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Navbar from "./Components/Navbar";
import SpinnerLoading from "./Components/SpinnerLoading";
import Login from "./pages/Login";
import FirstStep from "./pages/QuoteStep/FirstStep";
import TitularData from "./pages/QuoteStep/TitularData";
import HomeData from "./pages/QuoteStep/HomeData";
import VehicleData from "./pages/QuoteStep/VehicleData";
import PayMethod from "./pages/QuoteStep/PayMethod";
import Confirm from "./pages/QuoteStep/Confirm";
import BeneficiaryData from "./pages/QuoteStep/BeneficiaryData";
import Menu from "./pages/Menu";
import Forgotten from "./pages/Forgotten";
import TecnologyData from "./pages/QuoteStep/TecnologyData";
import Settings from "./pages/Settings";
import AdminPrices from "./pages/AdminPrices";
import Pets from "./pages/QuoteStep/Pets";
import FilesMovt from "./pages/FilesMovt";

const Users = lazy(() => import("./pages/ABM/Users"));
const Sucursales = lazy(() => import("./pages/ABM/Sucursales"));
const Regions = lazy(() => import("./pages/ABM/Regions"));
const Zones = lazy(() => import("./pages/ABM/Zones"));
const Profile = lazy(() => import("./pages/Profile"));
const Policies = lazy(() => import("./pages/Policies"));
const Phones = lazy(() => import("./pages/Phones"));
const Files = lazy(() => import("./pages/Files"));
const GenerarAltas = lazy(() => import("./pages/GenerarAltas"));
const ProductsFiles = lazy(() => import("./pages/ProductsFiles"));
const Statics = lazy(() => import("./pages/Statics"));
const AdminStatics = lazy(() => import("./pages/AdminStatics"));
const Relocation = lazy(() => import("./pages/Relocation"));
const Version = lazy(() => import("./pages/Version"));
const Auditory = lazy(() => import("./pages/Auditory"));
const Certificate = lazy(() => import("./pages/Certificate"));
const Logs = lazy(() => import("./pages/Logs"));
const Policy = lazy(() => import("./pages/Policy"));
const Sinister = lazy(() => import("./pages/Sinister"));
const Sinisters = lazy(() => import("./pages/Sinisters"));
const SyncFiles = lazy(() => import("./pages/SyncFiles"))

function App({ user, logIn, loadConfirmCode, infoCompany }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const backgroundImage = './assets/newBackground.png';


  const [backgroundStyle, setBackgroundStyle] = useState({
    background: `url('${backgroundImage}')`,
    // position: 'absolute',
    // zIndex: -2,
    
  });


  const handleImageError = () => {
    // Cambia la imagen de fondo a la por defecto si la imagen original no carga
    setBackgroundStyle({
      ...backgroundStyle,
      background: `url('./assets/newBackground.png') repeat-x`,
    });
  };

  const getParams = () => {
    return {
      token: searchParams.get("tkn"),
      nro: searchParams.get("nro"),
      nombre: searchParams.get("Nombre"),
      apellido: searchParams.get("Apellido"),
      dni: searchParams.get("Dni"),
      sexo: searchParams.get("Sexo"),
      fecnac: searchParams.get("FechaNacimiento"),
      domicilio: searchParams.get("Domicilio"),
      codpos: searchParams.get("CodigoPostal"),
      city: searchParams.get("Localidad"),
      localidad: searchParams.get("Localidad"),
      provincia: searchParams.get("Provincia"),
      area: searchParams.get("PrefijoCelular"),
      telefono: searchParams.get("Celular"),
      celular: searchParams.get("Celular"),
      email: searchParams.get("Email"),
      nacionalidad: searchParams.get("Nacionalidad"),
      confirmCode: searchParams.get("codigo"),
      grupo: searchParams.get("Grupo"),
    }
  };

  useEffect(() => {
    const params = getParams();
    localStorage.removeItem('hash');
    localStorage.removeItem('date');
    const test = params.token?.startsWith("!"); //
    if (params.token) {
      logIn({ ...params, test });
    } else if (!user.login && params.confirmCode) {
      loadConfirmCode(params.confirmCode);
    }
  }, []);

  useEffect(() => {
    if (user.login) {
      //Usuario solo lectura de siniestros
      if (user.opcusu[0] === "9") {
        navigate("/sinisters");
      }
    }
  }, [user]);


  useEffect(() => {
    if (infoCompany.abremp !== "") {
      const img = new Image();
      img.src = `https://www.platform.com.ar/assets/background/${infoCompany.abremp}.png`;
      img.onload = () => {
        // La imagen de fondo original cargó correctamente
        setBackgroundStyle({
          ...backgroundStyle,
          background: `url('https://www.platform.com.ar/assets/background/${infoCompany.abremp}.png')`,
          "background-size": "cover",
        });
      };
      img.onerror = handleImageError;
    }
  }, [infoCompany.abremp]);

  return (
    <>
      {
        user.login ? (
          <div className="App">
            <Navbar />
            <div style={backgroundStyle} className="propsBackground">
              <Suspense fallback={<SpinnerLoading />}>
                <Routes>
                  {/* Rutas de las ventas */}
                  <Route path='/' element={<Menu />} />
                  <Route path='/qs/firstStep/' element={<FirstStep />} />
                  <Route path='/qs/titularData/' element={<TitularData />} />
                  <Route path='/qs/beneficiaryData/' element={<BeneficiaryData />} />
                  <Route path='/qs/homeData/' element={<HomeData />} />
                  <Route path='/qs/pets/' element={<Pets />} />
                  <Route path='/qs/tecnologyData/' element={<TecnologyData />} />
                  <Route path='/qs/vehicleData/' element={<VehicleData />} />
                  <Route path='/qs/payMethod/' element={<PayMethod />} />
                  <Route path='/qs/confirm/' element={<Confirm />} />

                  {/* Rutas del admin */}
                  <Route path='/policy/' element={<Policies />} />
                  <Route path='/policy/:id' element={<Policy />} />

                  <Route path='/stcs/:type' element={<Statics />} />
                  <Route path='/adminStatics' element={<AdminStatics />} />
                  <Route path='/auditory/' element={<Auditory />} />

                  <Route path='/sinister/' element={<Sinister />} />
                  <Route path='/sinister/:id' element={<Sinister />} />
                  <Route path='/sinisters/' element={<Sinisters />} />

                  {/* ABMs */}
                  <Route path='/users/' element={<Users />} />
                  <Route path='/sucursales/' element={<Sucursales />} />
                  <Route path='/regions/' element={<Regions />} />
                  <Route path='/zones/' element={<Zones />} />
                  {/* ABMs */}

                  <Route path='/settings/' element={<Settings />} />
                  <Route path='/prices/' element={<AdminPrices />} />
                  <Route path='/relocation/' element={<Relocation />} />
                  <Route path='/files/' element={<Files />} />
                  <Route path='/movtFiles/' element={<FilesMovt />} />
                  <Route path='/newState/' element={<GenerarAltas />} />
                  <Route path='/productsFiles/' element={<ProductsFiles />} />
                  <Route path='/syncFiles/' element={<SyncFiles />} />
                  <Route path='/phones/' element={<Phones />} />

                  <Route path='/version/' element={<Version />} />
                  <Route path='/logs/' element={<Logs />} />
                  <Route path='/profile/' element={<Profile />} />
                  <Route path='/certificate/' element={<Certificate />} />
                </Routes>
              </Suspense>
            </div>
          </div>
        ) : (
          window.location.href?.includes("#/forgotten")
            ? <Forgotten />
            : <Login tkn={searchParams.get("tkn")} />
        )
      }
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.mainReducer.user,
    infoCompany: state.mainReducer.infoCompany,
    homeData: state.mainReducer.homeData,
  }
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
